/* jshint esversion: 6 */

import {EncryptionModifier} from "encryption/EncryptionModifier";
import {Ascii} from "common/Ascii";

const DEFAULT_CRYPT_TOKEN = EncryptionModifier.getDefaultCryptToken(),
    CODE_OR_VAL = EncryptionModifier.getCodeOrVal();

/**
 *  Utilitie class for data decryption
 *
 *  uses the deprecated 'escape()' command.
 *  Unfortunately it's not that easy to replace it
 *  because the data consumption of ather encoder as e.g. encodeURI is much higher.
 *  TODO <TR20181210>: Find another way to encrypt the data
 * @param cryptToken default is 0x2A
 * @param useLegacyEncoder default is true
 * @returns {{decryptData: decryptData}}
 */
export function Decryptor(cryptToken = DEFAULT_CRYPT_TOKEN, useLegacyEncoder = true) {
    const hexMap = EncryptionModifier.getHexMap();
    const decodeUriParts = useLegacyEncoder ? unescape : decodeURI;

    function decryptCharsFromMap(encrypted) {
        encrypted = encrypted.substring(1);
        hexMap.forEach((value, key) => {
            const regExp = createCharRegExp(value);
            encrypted = encrypted.replace(regExp, key);
        });
        return encrypted;
    }

    function createCharRegExp(value) {
        const charCode = value.charCodeAt(0),
            pattern = Ascii.isLetter(charCode) ? value : `\\${value}`;

        return new RegExp(pattern, "g");
    }

    function getCharsWithPercentage(data) {
        let encodedWithPercent = "";
        for (let i = 0; i < data.length; i += 2) {
            encodedWithPercent += `%${data.substring(i, i + 2)}`;
        }
        return encodedWithPercent;
    }

    function isEncrypted(data) {
        return data.charAt(0).charCodeAt(0) === cryptToken;
    }

    function decrypt(data) {
        let decrypt = decryptCharsFromMap(data);
        decrypt = getCharsWithPercentage(decrypt);
        decrypt = decodeUriParts(decrypt);
        return shiftLetters(decrypt);
    }

    function shiftLetters(data) {
        let shiftedData = "";
        for (let i = 0; i < data.length; i++) {
            shiftedData += String.fromCharCode(data.charCodeAt(i) ^ CODE_OR_VAL);
        }
        return shiftedData;
    }

    // revealing public api
    return {
        decryptData: function (data) {

            if (!data || typeof data !== "string") {
                return "";
            }

            if (!isEncrypted(data)) {
                return data;
            }

            return decrypt(data);
        }
    };
}
